type TodoItemProps = {
    id: string;
    internetMessageId: string;
    taskSummary: string;
    linkedEventId?: string;
    done: boolean;
    isUserAccepted?: boolean;
    checkedDate?: string | null;
};

export default class TodoItem {
    id: string;

    internetMessageId: string;

    taskSummary: string;

    linkedEventId?: string;

    done: boolean;

    isUserAccepted?: boolean;

    checkedDate: string | null;

    constructor({
        id,
        internetMessageId,
        taskSummary,
        linkedEventId,
        done,
        isUserAccepted,
        checkedDate = null,
    }: TodoItemProps) {
        this.id = id;
        this.internetMessageId = internetMessageId;
        this.taskSummary = taskSummary;
        this.linkedEventId = linkedEventId;
        this.done = done;
        this.isUserAccepted = isUserAccepted;
        this.checkedDate = checkedDate;
    }
}
